//import { initializeApp } from "firebase/app";
import { captureCipcApprovalToken } from "../utils/cipcApprovalToken";
import firebase from "firebase/compat/app";

import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/functions";
import "firebase/compat/app-check";
import "firebase/compat/analytics";
import "firebase/compat/storage";
import "firebase/compat/firestore";
import { initializeApp, getApp, getApps } from "firebase/app";
import {
  getAI,
  getGenerativeModel,
  GoogleAIBackend,
  Schema,
} from "firebase/ai";
import {
  getAuth,
  onAuthStateChanged as onAuthStateChangedMod,
  signInWithEmailAndPassword as signInWithEmailAndPasswordMod,
  createUserWithEmailAndPassword as createUserWithEmailAndPasswordMod,
  signOut as signOutMod,
} from "firebase/auth";

// const {
//   initializeAppCheck,
//   ReCaptchaV3Provider,
// } = require("firebase/app-check");
// const { initializeApp } = require("firebase/app");
// //import { getDatabase, ref, onValue } from "firebase/database";
// import { getAuth } from "firebase/auth";

//import "firebase/firestore";

// used for authentication
//var database = firebase.database();
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
captureCipcApprovalToken();
let config = {
  apiKey: "AIzaSyBYnc2ysweStJ-TIhjcbNkpfKKjq83T2Zo",
  authDomain: "filing-stack.firebaseapp.com",
  databaseURL: "https://filing-stack-default-rtdb.firebaseio.com",
  projectId: "filing-stack",
  storageBucket: "filing-stack.appspot.com",
  messagingSenderId: "988772706269",
  appId: "1:988772706269:web:40943029a378ab7a1ab834",
  measurementId: "G-K97Q70EFJP",
};

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// Initialize modular app first; reuse if already created
const appModular = getApps().length ? getApp() : initializeApp(config);
// Bridge compat to the same default app
const app =
  firebase.apps && firebase.apps.length
    ? firebase.app()
    : firebase.initializeApp(config);

// const {
//   initializeAppCheck,
//   ReCaptchaEnterpriseProvider,
// } = require("firebase/app-check");
// Initialize Firebase
//const app = firebase.initializeApp(firebaseConfig);
//remove in production

if (
  typeof window !== "undefined" &&
  process.env.NODE_ENV === "development" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1")
) {
  window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}
//
// Provide a JSON schema object using a standard format.
// Later, pass this schema object into `responseSchema` in the generation config.
const jsonSchema = Schema.object({
  properties: {
    characters: Schema.array({
      items: Schema.object({
        properties: {
          id: Schema.string(),
          account_group: Schema.string(),
          vatType: Schema.string(),
          // vatAmount: Schema.number(),
          // species: Schema.string(),
        },
        //  optionalProperties: ["accessory"],
      }),
    }),
  },
});

// Schema specifically for live chat AI responses
const chatResponseSchema = Schema.object({
  properties: {
    response: Schema.string({
      description: "The AI assistant's response to the user's question",
    }),
    confidence: Schema.string({
      description:
        "How confident the AI is in the response: high, medium, or low",
    }),
    category: Schema.string({
      description:
        "Category of the question: accounting, technical, billing, general",
    }),
    needsHumanSupport: Schema.boolean({
      description: "Whether this query should be escalated to human support",
    }),
  },
  required: ["response"],
});

// Initialize Firebase AI with error handling
let ai = null;
let model = null;
let chatModel = null;
let notesModel = null; // Dedicated model for IFRS Notes JSON outputs
let auditModel = null; // Dedicated model for Audit Working Papers
let migrationModel = null; // Dedicated model for Migration/Onboarding Account Mapping

try {
  // Initialize the Gemini Developer API backend service
  ai = getAI(appModular, { backend: new GoogleAIBackend() });

  // Create a `GenerativeModel` instance with a model that supports your use case (for accounting data)
  model = getGenerativeModel(ai, {
    model: "gemini-3.1-flash-lite-preview", // In the generation config, set the `responseMimeType` to `application/json`
    // and pass the JSON schema object into `responseSchema`.
    generationConfig: {
      responseMimeType: "application/json",
      responseSchema: jsonSchema,
      maxOutputTokens: 8192, // Increased to handle larger batch responses
    },
  });

  // Create a separate model specifically for live chat responses
  chatModel = getGenerativeModel(ai, {
    model: "gemini-3-flash-preview",
    generationConfig: {
      responseMimeType: "application/json",
      responseSchema: chatResponseSchema,
      temperature: 0.7, // Make responses more conversational
      maxOutputTokens: 1024,
    },
  });

  // Schema for IFRS Notes suggestions
  const notesSchema = Schema.object({
    properties: {
      notes: Schema.array({
        items: Schema.object({
          properties: {
            key: Schema.string({ description: "Stable note identifier" }),
            title: Schema.string({ description: "Human-friendly note title" }),
            Name: Schema.string({ description: "Note name to save" }),
            NumberOfRows: Schema.number({
              description: "Rows*5 per app convention",
            }),
            NumberOfColumns: Schema.number({
              description: "Cols*15 per app convention",
            }),
            columnData1: Schema.string({
              description: "Optional content column",
            }),
            columnData2: Schema.string({}),
            columnData3: Schema.string({}),
            columnData4: Schema.string({}),
            columnData5: Schema.string({}),
            rationale: Schema.string({
              description: "Why this note is relevant",
            }),
          },
        }),
      }),
    },
  });

  // Create a model configured for IFRS notes JSON
  notesModel = getGenerativeModel(ai, {
    model: "gemini-3-flash-preview",
    generationConfig: {
      responseMimeType: "application/json",
      responseSchema: notesSchema,
      temperature: 0.2,
      maxOutputTokens: 2048,
    },
  });

  // Schema for Audit Working Papers (SAICA/SAIPA aligned)
  const auditSchema = Schema.object({
    properties: {
      workingPapers: Schema.array({
        items: Schema.object({
          properties: {
            accountName: Schema.string({ description: "Name of the account" }),
            riskLevel: Schema.string({
              description: "High, Medium, or Low based on balance/nature",
            }),
            assertions: Schema.array({
              items: Schema.string(),
              description:
                "Applicable assertions: Existence, Completeness, Valuation, Rights, etc.",
            }),
            procedures: Schema.array({
              items: Schema.string(),
              description:
                "List of specific substantive audit procedures to perform",
            }),
            sampleSize: Schema.string({
              description:
                "Recommended sample size (e.g., 'Top 10 + random 5')",
            }),
          },
        }),
      }),
    },
  });

  // Create a model configured for Audit generation
  auditModel = getGenerativeModel(ai, {
    model: "gemini-3-flash-preview",
    generationConfig: {
      responseMimeType: "application/json",
      responseSchema: auditSchema,
      temperature: 0.1, // Low temperature for strict compliance adherence
    },
  });

  // Schema for Migration/Onboarding (Mapping External Trial Balances)
  const migrationSchema = Schema.object({
    properties: {
      mappedAccounts: Schema.array({
        items: Schema.object({
          properties: {
            originalName: Schema.string({
              description: "The account name from the uploaded file",
            }),
            suggestedGroup: Schema.string({
              description:
                "The closest matching internal Account Group (e.g., 'Bank Fees', 'Sales', 'Cost of Sales', 'Rent Paid')",
            }),
            confidence: Schema.number({
              description: "Confidence score between 0 and 1",
            }),
            type: Schema.string({
              description:
                "Financial Statement Type: 'Income', 'Expense', 'Asset', 'Liability', 'Equity'",
            }),
            reasoning: Schema.string({
              description: "Brief reason for this classification",
            }),
          },
        }),
      }),
    },
  });

  // Create a model configured for Migration mapping
  migrationModel = getGenerativeModel(ai, {
    model: "gemini-3.1-flash-lite-preview",
    generationConfig: {
      responseMimeType: "application/json",
      responseSchema: migrationSchema,
      temperature: 0.1,
    },
  });

  console.log("Firebase AI initialized successfully");
} catch (error) {
  console.warn("Firebase AI service not available:", error.message);
  console.log(
    "AI features will be disabled. Please ensure Firebase AI is enabled in your console.",
  );
}

// Export AI services (will be null if initialization failed)
export { ai };

function _normalizeAdaptivePrompt(input) {
  if (typeof input === "string") {
    return input;
  }

  if (Array.isArray(input)) {
    return input
      .map((part) => {
        if (typeof part === "string") {
          return part;
        }

        if (part && typeof part === "object") {
          if (typeof part.text === "string") {
            return part.text;
          }

          if (part.inlineData && part.inlineData.mimeType) {
            return `[inlineData:${part.inlineData.mimeType}]`;
          }

          try {
            return JSON.stringify(part);
          } catch (_) {
            return String(part);
          }
        }

        return String(part ?? "");
      })
      .join("\n");
  }

  return String(input ?? "");
}

function _buildAdaptiveCandidates(text, finishReason, candidates) {
  if (Array.isArray(candidates) && candidates.length > 0) {
    return candidates;
  }

  return [
    {
      finishReason: finishReason || "STOP",
      content: {
        parts: text ? [{ text }] : [],
      },
    },
  ];
}

function _buildAdaptiveResult(resultData = {}) {
  const text = typeof resultData.text === "string" ? resultData.text : "";
  const parsed =
    resultData && Object.prototype.hasOwnProperty.call(resultData, "parsed")
      ? resultData.parsed
      : null;
  const candidates = _buildAdaptiveCandidates(
    text,
    resultData.finishReason,
    resultData.candidates,
  );

  return {
    response: {
      text: () => text,
      parsed,
      candidates,
    },
    candidates,
  };
}

/**
 * Create an OpenAI-first model wrapper. Gemini remains as a fallback only if
 * the OpenAI function path is unavailable at runtime.
 * Returned object is interface-compatible with a Gemini GenerativeModel.
 */
function _makeAdaptiveModel(geminiModelRef, openAIFunctionName) {
  return {
    generateContent: async (...args) => {
      const input = args[0];
      const prompt = _normalizeAdaptivePrompt(input);

      try {
        const callable = functions.httpsCallable(openAIFunctionName);
        const result = await callable({ prompt });
        return _buildAdaptiveResult(result.data || {});
      } catch (openAIError) {
        if (!geminiModelRef) {
          // No fallback available — surface the real error
          console.error(
            `OpenAI function ${openAIFunctionName} failed and Gemini is unavailable:`,
            openAIError,
          );
          throw openAIError;
        }
        console.warn(
          `OpenAI function ${openAIFunctionName} failed, falling back to Gemini:`,
          openAIError,
        );
      }

      return geminiModelRef.generateContent(...args);
    },
  };
}

// Save Gemini model references, then reassign with adaptive wrappers
const _gModel = model;
const _gChatModel = chatModel;
const _gNotesModel = notesModel;
const _gAuditModel = auditModel;
const _gMigrationModel = migrationModel;

model = _makeAdaptiveModel(null, "openAIClassifyAccount");
chatModel = _makeAdaptiveModel(null, "openAIChatResponse");
notesModel = _makeAdaptiveModel(null, "openAINotesGeneration");
auditModel = _makeAdaptiveModel(null, "openAIAuditGeneration");
migrationModel = _makeAdaptiveModel(null, "openAIMigrationMapping");

// Export adaptive wrappers (+ raw ai for advanced inline usage)
export { model, chatModel, notesModel, auditModel, migrationModel };

// Initialize App Check with error handling
export let appCheck = null;
try {
  appCheck = firebase.appCheck();
  // Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
  // key is the counterpart to the secret key you set in the Firebase console.
  appCheck.activate(
    "6Lch3wMdAAAAAJrP7njIi78LH3IQVZVUUNEC2D5j",

    // Optional argument. If true, the SDK automatically refreshes App Check
    // tokens as needed.
    true,
  );
  console.log("Firebase App Check initialized successfully");
} catch (error) {
  console.warn("Firebase App Check initialization failed:", error.message);
  console.log("App will continue without App Check protection");
}

// Create a ReCaptchaEnterpriseProvider instance using your reCAPTCHA Enterprise
// site key and pass it to initializeAppCheck().
// const appCheckModular = initializeAppCheck(appModular, {
//   provider:
//     new ReCaptchaEnterpriseProvider(/* reCAPTCHA Enterprise site key */),
//   isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
// });
//export const database = firebase.database();
// Get a reference to the database service
export const database = firebase.database();
//export const refs = ref;
//export const onValues = onValue;

//
export const firestore = firebase.firestore();
// Provide auth in a way that works in browser (compat) and in tests (modular shim)
const __authModular = getAuth(appModular);
let __authExport = __authModular;

if (process.env.NODE_ENV === "test") {
  // In Jest/JSDOM, compat auth can fail to initialize; expose a small v8-like shim
  // on top of the modular instance so existing code keeps working in tests.
  __authExport.signInWithEmailAndPassword = (email, password) =>
    signInWithEmailAndPasswordMod(__authModular, email, password);
  __authExport.createUserWithEmailAndPassword = (email, password) =>
    createUserWithEmailAndPasswordMod(__authModular, email, password);
  __authExport.signOut = () => signOutMod(__authModular);
  __authExport.onAuthStateChanged = (callback) =>
    onAuthStateChangedMod(__authModular, callback);
} else {
  // In the browser/runtime, use compat to preserve v8 instance methods used across the app
  __authExport = firebase.auth();
}

export const auth = __authExport;
// Also export modular auth for new code and gradual migration (use with modular functions)
export const authModular = __authModular;
//auth.useEmulator("http://localhost:9099");

// US Central region functions (most functions)
export const functions = firebase.app().functions("us-central1");

// Point callable functions to the local emulator in developmentf (process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_EMULATOR === "true") {
//functions.useEmulator("localhost", 5001);

// South America region functions (for specific functions in that region)
export const functionsSA = firebase.app().functions("southamerica-east1");

export const analytics = firebase.analytics();

// POPIA/GDPR Compliance: Only enable Firebase Analytics if user has explicitly consented
if (typeof window !== "undefined") {
  const consent = localStorage.getItem("cookieConsent");
  if (consent === "accepted") {
    analytics.setAnalyticsCollectionEnabled(true);
  } else {
    analytics.setAnalyticsCollectionEnabled(false);
  }
}

export const storage = firebase.storage(app);

//export const Appfunctions = app.functions();
//removed export default app, may have to bring back
//export const app;

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
//reason for REACT_APP_FIREBASE_ before each config is react environmental variables must be prefixed with REACT_APP
